<template>
    <div
        v-if="stat && stat[itemid]"
        class="appear"
    >
        <span class="mr-3">
            <span class="fa fa-mouse-pointer" />
            Перешли по ссылке: {{ stat[itemid].users }}
        </span>
        <span class="mr-3">
            <span class="fa fa-shopping-cart" />
            Оформлено заказов: {{ stat[itemid].transactions }}
        </span>
        <span class="mr-3">
            <span class="fa fa-money" />
            Доход: {{ Math.round(stat[itemid].revenue) }}
        </span>
    </div>
    <div v-else />
</template>

<script>
    export default {
        name: 'EmailStat',
        props: {
            itemid: {
                type: Number,
                default: null,
            },
            stat: {
                type: Object,
                default: null,
            },
        },
        data: function() {
        },
    }
</script>
